module.exports = __webpack_public_path__ + "c12983249f1eda550319533dd808bd9e.png";